import useSWR from 'swr';
import { apiClient } from '@/lib/api-client';
import { realtimeSWRConfig } from '@/lib/swr-config';

export function useStats() {
  const { data, error, mutate, isValidating } = useSWR(
    '/stats',
    () => apiClient.getStats(),
    {
      ...realtimeSWRConfig,
      refreshInterval: 5000, // Update every 5 seconds
      revalidateOnFocus: true,
      dedupingInterval: 2000,
    }
  );

  return {
    stats: data,
    isLoading: !error && !data,
    isValidating,
    error,
    mutate,
  };
}
